import React from 'react';
import SharedBanner from '../../Shared/SharedBanner/SharedBanner';
import image from '../../../Assets/Backgrounds/frontBg.webp' ;
const Banner=()=>{
    return(
        <>
        <SharedBanner 
        backgroundImage={image}
        styles="noshade"
        title="Front End Developer"
        desc="We are looking for a Front End Developer. If you are a skilled Theme Developer with ThemeForest Experience, we are looking for you. 💯 🚀 🎉"
        />
        </>
    )
};
export default Banner ;